import React from "react";
import cssExports from "theme/styles/main.module.scss";
import { Grid } from "@mui/material";
//#region types
import { DetailsTableProps } from "models/propTypes/listPropTypes";
//#endregion
//#region components
import DetailsTable from "./detailsTable";
//#endregion
import clsx from "clsx";

const DetailsTableView: React.FC<DetailsTableProps> = (props) => {
  return (
    <Grid container className={clsx(cssExports.detailsTableView, props.className)}>
      <DetailsTable
        detailsList={props.detailsList}
        buttonText={props.buttonText}
        buttonOnClick={props.buttonOnClick}
        hideButton={props.hideButton}
        valueAlignment={props.valueAlignment}
      />
    </Grid>
  );
};

export default DetailsTableView;
